import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; // Import the auth context

const PrivateRoute = () => {
  const { user, loading } = useAuth(); // Access user and loading state from context

  // Show a loading state while checking authentication
  if (loading) {
    return <div className="text-center py-10">Loading...</div>;
  }

  // Redirect to login if the user is not authenticated
  return user ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
